import { render, staticRenderFns } from "./etcOrderNum.vue?vue&type=template&id=246e7ae0&scoped=true"
import script from "./etcOrderNum.vue?vue&type=script&lang=js"
export * from "./etcOrderNum.vue?vue&type=script&lang=js"
import style0 from "./etcOrderNum.vue?vue&type=style&index=0&id=246e7ae0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246e7ae0",
  null
  
)

export default component.exports